import { render, staticRenderFns } from "./MerchantAdd.vue?vue&type=template&id=7bd25974&"
import script from "./MerchantAdd.vue?vue&type=script&lang=js&"
export * from "./MerchantAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports